<template>
  <ul
    class="mainHeaderConnected navbar-nav ml-auto w-100"
    style="align-items: center"
  >
    <li
      v-if="$store.getters.isSandbox"
      class="mr-4"
    >
      <i class="fa fa-exclamation-triangle text-warning" /><span class="ml-2"><i>sandbox</i></span>
    </li>

    <li class="mainHeaderConnected__item nav-item show test mr-0">
      <MainHeaderNotifications v-if="displayActionReviewNotifications" />

      <NdsButton
        :color="NdsButtonColor.TERTIARY"
        :size="NdsButtonSize.S"
        @click="$emit('show-help')"
      >
        <NdsIcon
          :icon="NdsIconType.CIRCLE_HELP"
          :size="NdsIconSize.S"
        />
      </NdsButton>
    </li>

    <li
      v-if="!$store.getters.isPublic"
      class="show test"
    >
      <AdminWheelDropdown @refresh="(event, route) => $emit('refresh', event, route)" />
    </li>

    <li
      v-if="$store.getters.customers.length > 1"
      class="show"
    >
      <CustomerSelectorDropdown />
    </li>

    <li
      v-else-if="$store.getters.customers.length >= 0"
      class="mr-1 show"
    >
      <div class="nav-link customer">
        <span v-if="$store.getters.customer === $store.getters.none_label">
          <AppIcon
            class="icon-menu-wheel"
            color="primary"
            custom_icon="server"
            fa_type="far"
            icon_size="1rem"
          />
          <span>{{ $store.getters.instance }}</span>
        </span>
        <span v-else>
          {{ $store.getters.customer }}
        </span>
      </div>
    </li>

    <li
      class="show test"
      data-testid="toggle-user-menu"
    >
      <UserMenuDropdown />
    </li>

    <li v-if="$store.getters.impersonate_contributor">
      <i
        v-b-tooltip
        class="mr-3 ml-0 far helper text-size-main-header red fa-user-ninja"
        :title="_('Contributor mode')"
      />
    </li>
  </ul>
</template>

<script>
import AppIcon from '@/components/ui/AppIcon.vue'
import NdsButton from '@/components/NewDesignSystem/NdsButton/NdsButton.vue'
import { NdsButtonColor, NdsButtonSize } from '@/components/NewDesignSystem/NdsButton/NdsButton.interfaces'
import AdminWheelDropdown from '@/components/layout/main-header/connected/AdminWheelDropdown.vue'
import CustomerSelectorDropdown from '@/components/layout/main-header/connected/CustomerSelectorDropdown.vue'
import UserMenuDropdown from '@/components/layout/main-header/connected/UserMenuDropdown.vue'
import MainHeaderNotifications from '@/components/layout/main-header/connected/MainHeaderNotifications.vue'
import NdsIcon from '@/components/NewDesignSystem/NdsIcon/NdsIcon.vue'
import { NdsIconSize, NdsIconType } from '@/components/NewDesignSystem/NdsIcon/NdsIcon.interfaces'
import { useActionReviewPreference } from '@/contexts/action-plans/action/Action.composables'

export default {
  name: 'MainHeaderConnected',
  components: {
    AppIcon,
    NdsButton,
    AdminWheelDropdown,
    CustomerSelectorDropdown,
    UserMenuDropdown,
    MainHeaderNotifications,
    NdsIcon,
  },
  setup() {
    const { hasActionReviewPreference } = useActionReviewPreference()

    return {
      hasActionReviewPreference,
    }
  },
  data() {
    return {
      NdsButtonColor,
      NdsButtonSize,
      NdsIconType,
      NdsIconSize,
    }
  },
  computed: {
    displayActionReviewNotifications() {
      return (
        this.hasActionReviewPreference &&
        !this.$store.getters.isAuditor &&
        !this.$store.getters.isPublic &&
        !this.$store.getters.isOnlyContributor
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.mainHeaderConnected {
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.text-size-main-header {
  font-size: 130% !important;
}

.helper {
  cursor: pointer;
}

.customer {
  font-size: 15px;
  line-height: 22px;
  font-weight: 400;
  cursor: pointer;
}

.icon-menu-wheel {
  margin-right: 8px !important;
}
</style>
